import React from "react";
import { FieldValues, useFormContext } from "react-hook-form";
import { LabelledRadioGroupField } from "../fields/LabelledRadioGroupField";
import { customRegister } from "./util";

type Props = {
  options: {
    value: string;
    label: string;
    description: string;
  }[];
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const LabelledRadioGroupInput = ({ name, onChange, ...rest }: Props) => {
  const { register } = useFormContext();

  const {
    ref,
    onChange: hookOnChange,
    ...hookFormProps
  } = customRegister<FieldValues>(name as string, register);

  const customOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    hookOnChange(e);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <LabelledRadioGroupField
      innerRef={ref}
      onChange={customOnChange}
      {...rest}
      {...hookFormProps}
    />
  );
};
